/**
 *
 * PageIndicator
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    height: 30,
    alignItems: 'center',
  },
  container: {
    display: 'flex',
    height: 5,
    width: '100%',
    paddingLeft: 20,
    paddingRight: 20,
    justifyContent: 'center',
    '& > div:first-child': {
      borderTopLeftRadius: 2.5,
      borderBottomLeftRadius: 2.5,
      marginLeft: '0 !important',
    },
    '& > div:last-child': {
      borderTopRightRadius: 2.5,
      borderBottomRightRadius: 2.5,
      marginRight: '0 !important',
    },
  },
  bar: {
    flex: 1,
    height: '100%',
    backgroundColor: '#E3E3E3',
    marginLeft: 2,
    marginRight: 2,
  },
  active: {
    backgroundColor: 'rgb(0, 179, 40)',
  },
});

function PageIndicator({ progress, size }) {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        {Array.from({ length: size }, (_, k) => k + 1).map((_, i) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={`pageIndicator-${i}`}
            className={classNames({
              [classes.bar]: true,
              [classes.active]: i <= progress,
            })}
          />
        ))}
      </div>
    </div>
  );
}

PageIndicator.propTypes = {
  progress: PropTypes.number,
  size: PropTypes.number,
};

export default PageIndicator;
